import bannerVideo from "../assets/bannervideo.mp4";
import logo from "../assets/logo.png";
import aboutImage from "../assets/12_Group Picture_geolocation and Mapping.jpeg";
import serviceMappingImage from "../assets/09_Geolocation_Mapping.jpeg";
import serviceLandImage from "../assets/2_Land_Surveying_Levelling.jpeg";
import serviceDroneImage from "../assets/satellite_image.jpg";
import serviceLidarImage from "../assets/6_Drone.jpeg";
import GeolocationCollage from "../assets/geolocationCollage.jpg";
import SurveyingCollage from "../assets/surveyingCollage.jpg";
import SatelitteCollage from "../assets/satelliteCollage.jpg";
import LidarCollage from "../assets/lidaroutput3.jpg";
import industryManufacturingImage from "../assets/manufacturing.png";
import industryEnergyImage from "../assets/energy.jpg";
import industryConstructionImage from "../assets/construction.jpg";
import industryAgricultureImage from "../assets/agriculture.png";
import industryTourismImage from "../assets/tourism.jpg";
import industryTransportImage from "../assets/transportation.png";
import industryLandImage from "../assets/land.jpg";
import industryMiningImage from "../assets/mining.png";
import industrySpaceImage from "../assets/space.png";
import industryBankingImage from "../assets/banking.png";
import edwardImage from "../assets/Edward Muyanja.png";
import tumainiImage from "../assets/Tumaini Thobias.png";
import nanyorriImage from "../assets/Nanyorri Ngalesoni.png";
import alexImage from "../assets/Dr.Alex Lubida.png";
import gilliardImage from "../assets/Gilliard Maliaki.png";
import partner1 from "../assets/partner1.png";
import partner2 from "../assets/partner2.png";
import partner3 from "../assets/partner3.png";
import partner4 from "../assets/partner4.png";
import partner5 from "../assets/partner5.png";
import partner6 from "../assets/partner6.png";
import partner7 from "../assets/partner7.png";
import partner8 from "../assets/partner8.png";
import partner9 from "../assets/partner9.png";
import partner10 from "../assets/partner10.png";
import partner11 from "../assets/partner11.png";
import partner12 from "../assets/partner12.png";
import partner13 from "../assets/partner13.gif";
import partner14 from "../assets/partner14.png";
import partner15 from "../assets/partner15.png";
import partner16 from "../assets/partner16.png";
import partner17 from "../assets/partner17.png";
import partner18 from "../assets/partner18.png";

export const companyInfo = {
  name: "Africa Geospatial Solutions",
  shortName: "AGS",
  tagline: "Unlocking Africa's Potential through Precise Geospatial Solutions",
  email: "info@africaspatial.co.tz",
  phoneDisplay: "+255 676 373373",
  phoneLink: "tel:+255676373373",
  address:
    "Morocco Square, Treasury Registrar Tower, 4th Floor, Mwai Kibaki Road, Kinondoni, Dar es Salaam.",
  headquarters: "Dar es Salaam, Tanzania",
  branches: ["Dar es Salaam", "Arusha", "Kigali, Rwanda"],
  logo,
  bannerVideo,
};

export const navItems = {
  topLevel: [
    { label: "Home", item: "home" },
    {
      label: "Who are we",
      item: "about",
      dropdown: [
        { label: "About Us", item: "about" },
        { label: "Our Team", item: "team" },
      ],
    },
    {
      label: "What do we do",
      item: "services",
      dropdown: [
        { label: "Industry", item: "industry" },
        { label: "Services", item: "services" },
      ],
    },
    { label: "Gallery", item: "gallery" },
    { label: "News & Updates", item: "news" },
    { label: "Contact Us", item: "contact" },
  ],
  mobile: [
    { label: "Home", item: "home" },
    { label: "About Us", item: "about" },
    { label: "Our Team", item: "team" },
    { label: "Industry", item: "industry" },
    { label: "Services", item: "services" },
    { label: "Gallery", item: "gallery" },
    { label: "News & Updates", item: "news" },
    { label: "Contact Us", item: "contact" },
  ],
};

export const homeHero = {
  eyebrow: "Precision Mapping. Regional Insight. Practical Delivery.",
  title: "Unlocking Africa's Potential through Precise Geospatial Solutions",
  description:
    "Survey • Mapping • GIS • Remote Sensing",
  buttonLabel: "Explore Now",
  highlights: [
    "Survey and mapping solutions for public and private sector projects",
    "Drone, GNSS, LiDAR, and GIS capabilities under one team",
    "Regional delivery with headquarters in Dar es Salaam and branches in Arusha and Kilimanjaro",
  ],
};

export const aboutContent = {
  heroTitle:
    "Transforming Africa's Geospatial Landscape with Precision and Vision",
  introTitle: "Why AGS is the Preferred Choice",
  intro: `Africa Geospatial Solutions Ltd (AGS) is a privately owned geospatial, 
          surveying, and mapping company headquartered in Dar es Salaam, Tanzania, 
          with branch offices in Arusha, Tanzania, and Kigali, Rwanda. We specialize 
          in delivering innovative geospatial solutions, survey and mapping services, 
          and end-to-end project management support to clients across diverse sectors.`,

  mission: `To become one of the leading providers of specialized geospatial services 
            in East Africa and the broader African region. We are driven by the vision 
            of pioneering geospatial excellence and setting the standard for 
            specialized solutions in the field. We aim to drive geospatial innovation 
            and redefine the landscape of geospatial services not only in Tanzania but 
            throughout Africa.`,

  vision: `To transform the way Africa perceives and utilises geospatial information. \
           We envision a future where geospatial technologies and solutions are 
           seamlessly integrated into various sectors, driving sustainable development, 
           informed decision-making, and improved quality of life across the continent. 
           With our expertise and innovative approach, we strive to be at the forefront 
           of geospatial solutions.`,
           
  image: aboutImage,
  historyTitle: "Our Journey and Evolution",
  p1: `Founded on a vision conceived in 2019, AGS was established to address the 
       growing demand for modern, technology-driven geospatial solutions. As industries 
       increasingly rely on accurate spatial data for planning, development, 
       and decision-making, we recognized the need to provide advanced surveying, 
       mapping, and geographic information services that meet high professional 
       standards.`,

  p2: `At AGS, we combine cutting-edge technologies, industry expertise, and a 
       client-focused approach to deliver accurate, reliable, and actionable geospatial 
       information. We understand that today’s development, infrastructure, 
       environmental, and resource management challenges require precise data, 
       innovative thinking, and technical excellence.`,

  p3: `Our capabilities are built on the integration of advanced geospatial 
       technologies and include Geolocation & Mapping, GIS and Spatial Data Analysis, 
       Remote Sensing and High-Resolution Satellite Imagery, Drone/UAV & LiDAR 
       Surveying, and Geospatial Data Management. These core services are seamlessly 
       combined to deliver accurate mapping, detailed spatial insights, and intelligent 
       geospatial solutions that support infrastructure development, environmental 
       monitoring, asset management, and data-driven decision-making across multiple 
       sectors.`,

  p4: `Through continuous investment in modern equipment, geospatial technologies, 
  and professional expertise, we help clients transform geographic data into valuable 
  insights that support informed decision-making and sustainable growth. Our commitment 
  to quality and innovation enables us to provide customised solutions tailored to the 
  unique requirements of each project.`,     
  values: [
    {
      title: "Precision by Default",
      text: "Every survey, model, and map is developed with disciplined field methods and accurate validation workflows.",
    },
    {
      title: "Technology With Purpose",
      text: "We combine GNSS, drones, LiDAR, and spatial analytics to solve real operational and planning challenges.",
    },
    {
      title: "Africa-Centered Delivery",
      text: "Our work is shaped by regional realities, local partnerships, and long-term value for African development.",
    },
  ],
};

export const faqs = [
  {
    question: "What industries can benefit from GIS?",
    answer:
      "GIS has applications in urban planning, real estate, environmental management, transportation and logistics, utilities and infrastructure, natural resource management, agriculture, emergency management, and public health, among many other sectors.",
  },
  {
    question: "Can you help with data collection and analysis?",
    answer:
      "Yes. We provide comprehensive data collection services, including spatial data acquisition, cleaning, validation, and advanced analysis techniques such as spatial modeling, geostatistics, and spatial querying.",
  },
  {
    question: "How can GIS benefit my business or organization?",
    answer:
      "GIS helps organizations analyze trends, optimize resource allocation, improve logistics and routing, identify suitable locations for expansion, track assets, and visualize information in a spatial context for stronger decision-making.",
  },
  {
    question: "What services does your GIS company provide?",
    answer:
      "Our company offers spatial data analysis, map creation and visualization, geocoding and address matching, remote sensing, GIS database management, and custom GIS software development alongside a wider geospatial service portfolio.",
  },
  {
    question: "Is my data secure with your GIS company?",
    answer:
      "Data security is a top priority for us. We use industry best practices, reliable backup and recovery measures, and strict confidentiality workflows to protect the integrity and availability of client data.",
  },
];

export const services = [
  {
    slug: "geo-location-and-mapping",
    title: "Geo Location and Mapping",
    shortDescription:
      `We provide innovative geospatial solutions that enable organizations to visualize, 
       analyze, and manage location-based information for improved operational performance 
       and sustainable development`,
    description:
      `Geolocation provides the spatial coordinates needed for mapping, while mapping organizes 
       and visualizes those coordinates into meaningful geographic information. Together, they 
       support decision-making in fields such as environmental management, banking industry, 
       mining sector, transportation, agriculture, urban planning, and scientific research.`,
    features: [
      "Geographic Information Systems (GIS)",
      "Geospatial Data Collection & Integration",
      "Digital Mapping & Visualization",
      "Web-Based Mapping Solutions",
      "Asset & Infrastructure Mapping",
      "Spatial Analysis & Decision Support",
      "Environmental & Resource Monitoring"
    ],
    benefits: {
      title: "Why Choose Our Geospatial & Mapping Solutions?",
      points: [
        "Accurate and reliable spatial data acquisition ",
        "Advanced GIS and mapping technologies ",
        "Customized solutions tailored to client needs ",
        "Improved planning and operational efficiency ",
        "Enhanced asset visibility and management ",
        "Data-driven decision support and reporting ",
        "Scalable solutions for projects of all sizes"
      ]
    },
    visual: "mapping",
    image: serviceMappingImage,
    collage: GeolocationCollage,
  },
  {
    slug: "land-surveying-topographical-mapping",
    title: "Land Surveying & Topographical Mapping",
    shortDescription:
      "Accurate site measurements and terrain intelligence for engineering design, construction planning, and infrastructure layout.",
    description:
      `Accurate spatial information forms the foundation of successful 
       planning, design, development, and infrastructure projects. Our 
       Land Surveying & Topographical Mapping services provide precise 
       measurements and detailed representations of the Earth's surface, 
       enabling clients to make informed decisions throughout the project 
       lifecycle.`,
    features: [
      "Topographical Surveys",
      "Engineering Surveys",
      "Control Surveys",
      "Route & Corridor Surveys",
      "Site Planning Support",
      "Digital Terrain Modeling (DTM)",
      "Geospatial Data Processing & Mapping"
    ],
    benefits: {
      title: "Why Choose Our Land Surveying & Topographical Mapping Services?",
      points: [
        "High-precision measurements and reliable data",
        "Modern surveying equipment and technologies",
        "Experienced and qualified surveying professionals",
        "Comprehensive terrain and site analysis",
        "Accurate deliverables for planning and design",
        "Efficient project execution and reporting",
        "Compliance with industry standards and best practices."
      ]
    },
    visual: "topography",
    image: serviceLandImage,
    collage: SurveyingCollage,
  },
  {
    slug: "high-resolution-satellite-imagery",
    title: "High resolution satellite imagery",
    shortDescription:
      "High-detail aerial intelligence for site surveys, environmental monitoring, real estate, and precision planning.",
    description:
      `High-resolution satellite imagery is a major component of Remote 
       Sensing and is often integrated with GIS software for spatial 
       analysis, mapping, and decision-making. It is a powerful geospatial 
       resource that provides detailed, accurate, and timely information 
       about the Earth’s surface. Its integration with GIS, remote sensing, and modern analytical tools has significantly improved environmental monitoring, infrastructure planning, resource management, and scientific research.`,
    features: [
      "Satellite Imagery Acquisition",
      "Image Processing & Enhancement",
      "Change Detection & Monitoring",
      "Land Use & Land Cover Mapping",
      "Infrastructure & Asset Monitoring",
      "Environmental & Natural Resource Assessment",
      "Spatial Analysis & Decision Support"
    ],
    benefits: {
      title: "Why Choose Our Satellite Imagery Solutions?",
      points: [
        "Access to high-quality and up-to-date imagery", 
        "Wide-area coverage for regional and national projects", 
        "Cost-effective alternative to extensive field surveys",
        "Reliable data for monitoring and analysis",
        "Advanced image processing and interpretation capabilities",
        "Seamless integration with GIS and other geospatial systems",
        "Tailored solutions to meet project-specific need."

      ]
    },
    visual: "drone",
    image: serviceDroneImage,
    collage: SatelitteCollage,
  },
  {
    slug: "drone-uav-lidar-surveying",
    title: "Drone/UAV & LiDAR Surveying",
    shortDescription:
      "Advanced Earth observation, 3D terrain capture, and spatial analysis for resilient and data-rich project delivery.",
    description:
      `Drone/UAV and Light Detection and Ranging (LiDAR) surveying are 
       closely related to modern geospatial technologies. Drones can carry 
       LiDAR sensors to collect highly accurate elevation and terrain data 
       efficiently. The integration of UAVs and LiDAR improves the speed, 
       precision, and flexibility of topographic mapping and spatial 
       analysis and transformed modern geospatial data collection by 
       providing rapid, accurate, and detailed spatial information. 
       Their integration with photogrammetry, GIS, and remote sensing 
       technologies supports engineering, environmental management, urban 
       planning, disaster monitoring, and scientific research.`,
    features: [
      "Drone Aerial Surveys",
      "LiDAR Data Acquisition",
      "Topographic Mapping & Terrain Analysis",
      "Topographic Mapping & Terrain Analysis",
      "3D Mapping & Modeling",
      "Infrastructure Inspection & Monitoring",
      "Infrastructure Inspection & Monitoring",
      "Environmental & Resource Monitoring",
      "Environmental & Resource Monitoring"
    ],
    benefits: {
      title: "Why Choose Our Drone/UAV & LiDAR Solutions?",
      points: [
        "Rapid and efficient data acquisition",
        "High-accuracy terrain and elevation information",
        "Reduced fieldwork and operational costs",
        "Safe access to challenging or hazardous locations",
        "High-resolution imagery and detailed spatial datasets",
        "Advanced 3D visualization and analysis capabilities",
        "Seamless integration with GIS and other geospatial system"
      ]
    },
    visual: "lidar",
    image: serviceLidarImage,
    collage: LidarCollage,
  },
];

export const additionalServices = [
  "Spatial & Land Use Planning Services",
  "Mobile & Web Mapping Applications",
  "Navigation and Geo-Location Analytics",
  "Map Design and Production Services",
  "Geospatial Intelligence Solutions",
  "Real Time GPS Asset Tracking Service",
  "Hydrographic/Bathymetric Solution",
  "2D Modelling",
  "3D Modelling",
  "Assets Managements",
];

export const industries = [
  {
    title: "Energy and Utility",
    description:
      "Network mapping, asset monitoring, and route planning for resilient energy delivery.",
    stat: "Network Mapping",
    visual: "industry-energy",
    image: industryEnergyImage,
  },
  {
    title: "Infrastructure",
    description:
      "Survey control, terrain data, and field-to-office coordination for safer project execution.",
    stat: "Site Control",
    visual: "industry-construction",
    image: industryConstructionImage,
  },
  {
    title: "Agriculture",
    description:
      "Remote sensing, crop monitoring, and land-use intelligence that improve yield decisions.",
    stat: "Field Insight",
    visual: "industry-agriculture",
    image: industryAgricultureImage,
  },
  {
    title: "Tourism",
    description:
      "Destination mapping, route intelligence, and land analysis for visitor-focused experiences.",
    stat: "Visitor Mapping",
    visual: "industry-tourism",
    image: industryTourismImage,
  },
  {
    title: "Transportation",
    description:
      "Corridor planning, logistics routing, and infrastructure mapping for movement at scale.",
    stat: "Route Design",
    visual: "industry-transport",
    image: industryTransportImage,
  },
  {
    title: "Land and Real Estate",
    description:
      "Boundary clarity, site visualization, and location intelligence for confident investment.",
    stat: "Property Clarity",
    visual: "industry-real-estate",
    image: industryLandImage,
  },
  {
    title: "Mining",
    description:
      "Terrain analysis, monitoring, and mapping workflows for safe and data-driven extraction planning.",
    stat: "Terrain Models",
    visual: "industry-mining",
    image: industryMiningImage,
  },
  {
    title: "Space Agencies",
    description:
      "Satellite imaging, orbital mapping, and geospatial intelligence solutions for mission planning, earth observation, and aerospace research.",
    stat: "Satellite Mapping",
    visual: "industry-space",
    image: industrySpaceImage,
  },
  {
    title: "Banking Sector",
    description:
      "Location intelligence, branch network analysis, and geospatial risk assessment tools for smarter financial service expansion and secure operations.",
    stat: "Risk Analytics",
    visual: "industry-banking",
    image: industryBankingImage,
  },
];

export const industryOverview = {
  title: "Discover the Power of Geospatial Solutions Across Markets",
  intro:
    "AGS provides geospatial, GIS, and surveying solutions for the mining, energy, agriculture, infrastructure, transportation, tourism, manufacturing, and land management sectors.",
};

export const teamMembers = [
  {
    name: "Edward Muyanja",
    position: "Managing Director",
    image: edwardImage,
    linkedin: "https://www.linkedin.com/in/edward-muyanja",
    twitter: "https://x.com/edward_muyanja",
    bio: "Edward leads AGS strategy, partnerships, and project direction with a strong focus on geospatial innovation across East Africa.",
    education:
      "Background in geospatial leadership, field operations, and regional project management.",
  },
  {
    name: "Tumaini Thobias",
    position: "Operations Director",
    image: tumainiImage,
    linkedin: "https://www.linkedin.com/in/tumaini-thobias",
    twitter: "https://x.com/tumaini_thobias",
    bio: "Tumaini coordinates field delivery, quality control, and operational performance across AGS assignments.",
    education:
      "Experienced in operations management, survey logistics, and project execution workflows.",
  },
  {
    name: "Dr. Alex Lubida",
    position: "GIS Director",
    image: alexImage,
    linkedin: "https://www.linkedin.com/in/dr-alex-lubida",
    twitter: "https://x.com/dralex_lubida",
    bio: "Dr. Alex guides the GIS vision of AGS, shaping analysis workflows, mapping systems, and data intelligence programs.",
    education:
      "Advanced academic and professional experience in GIS, spatial analysis, and applied geospatial systems.",
  },
  {
    name: "Gilliard Maliaki",
    position: "Director Survey & Mapping",
    image: gilliardImage,
    linkedin: "https://www.linkedin.com/in/gilliard-maliaki",
    twitter: "https://x.com/gilliard_maliaki",
    bio: "Gilliard oversees survey and mapping delivery, ensuring field accuracy and dependable outputs for complex assignments.",
    education:
      "Professional experience in land surveying, topographic mapping, and engineering support surveys.",
  },
];

export const partners = [
  { image: partner1, alt: "Partner 1" },
  { image: partner2, alt: "Partner 2" },
  { image: partner3, alt: "Partner 3" },
  { image: partner4, alt: "Partner 4" },
  { image: partner5, alt: "Partner 5" },
  { image: partner6, alt: "Partner 6" },
  { image: partner7, alt: "Partner 7" },
  { image: partner8, alt: "Partner 8" },
  { image: partner9, alt: "Partner 9" },
  { image: partner10, alt: "Partner 10" },
  { image: partner11, alt: "Partner 11" },
  { image: partner12, alt: "Partner 12" },
  { image: partner13, alt: "Partner 13" },
  { image: partner14, alt: "Partner 14" },
  { image: partner15, alt: "Partner 15" },
  {image: partner16, alt: "Partner 16" },
  {image: partner17, alt: "Partner 17" },
  {image: partner18, alt: "Partner 18" },
];

export const stats = [
  { value: "3", label: "Regional offices supporting project delivery" },
  {
    value: "5",
    label: "Core geospatial specialties integrated under one brand",
  },
  { value: "8", label: "Primary industries served with location intelligence" },
  { value: "100%", label: "Focus on accurate, end-to-end project execution" },
];

export const contactDetails = [
  {
    label: "Call us",
    value: companyInfo.phoneDisplay,
    href: companyInfo.phoneLink,
  },
  {
    label: "Email",
    value: companyInfo.email,
    href: `mailto:${companyInfo.email}`,
  },
  {
    label: "Visit",
    value: companyInfo.address,
    href: "https://maps.google.com/?q=Minet+House+488+Haile+Selassie+Rd+Dar+es+Salaam",
  },
];
